import { Component, OnInit } from "@angular/core";
import { ProductService } from "src/app/core/services/product.service";
import { OrderService } from 'src/app/core/services/order.service';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalOrdersComponent } from "src/app/pages/home/components/modal-orders/modal-orders.component";

@Component({
  selector: "app-index",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.css"],
})
export class IndexComponent implements OnInit {
  typeMenu: number = 1;
  constructor(
    private productService: ProductService,
    private orderService: OrderService,
    private modalService: NgbModal,
    private route: ActivatedRoute
  ) {}

  async ngOnInit() {
    this.orderService.validateSession();
    this.getTypeMenu();
    const scan = this.orderService.getScan();
    if(scan){
      //console.log('si scan');
      this.orderService.removeScan();
      let orders = await this.orderService.getOrdenesMesaCount();
      if(orders.length>0){
        const modalReference = this.modalService.open(ModalOrdersComponent);
      }
    }
  }


  async getTypeMenu() {
    this.typeMenu = await this.productService.gettypeMenu();
  }
}
